<p-toast></p-toast>
<p-blockUI [blocked]="isPageLoading">
  <div class="block-ui-overlay">
    <i class="pi pi-spinner pi-spin block-ui-spinner"></i>
  </div>
</p-blockUI>

<app-direct-apply-landing *ngIf="currentStep === 0"
  (startApplication)="startFromLanding($event)"></app-direct-apply-landing>


<ng-container *ngIf="currentStep > 0">
  <div class="da-container" style="margin-top:-2rem; margin-bottom:-4rem;" *ngIf="daForm">
    <!-- SIDEBAR -->
    <aside class="da-sidebar">
      <!-- Desktop/Tablet Progress Indicator -->
      <div class="progress-indicator desktop-only">
        <div class="circle">
          <span class="step-count">{{ currentStep }}/4</span>
          <span class="step-text">steps</span>
        </div>
        <div class="in-progress">IN PROGRESS</div>
      </div>

      <!-- Mobile Progress Header -->
      <div class="mobile-progress-header mobile-only">
        <div class="circle mobile-circle">
          <span class="step-count">{{ currentStep }}/4</span>
          <span class="step-text">steps</span>
        </div>
        <div class="mobile-step-info">
          <h2 class="current-step-name">
            <ng-container *ngIf="currentStep === 1">DA Form</ng-container>
            <ng-container *ngIf="currentStep === 2">REVIEW</ng-container>
            <ng-container *ngIf="currentStep === 3">Payment</ng-container>
            <ng-container *ngIf="currentStep === 4">Confirmation</ng-container>
          </h2>
          <div class="next-step-name" *ngIf="currentStep < 4">
            Next &rarr;
            <ng-container *ngIf="currentStep === 1">REVIEW</ng-container>
            <ng-container *ngIf="currentStep === 2">Payment</ng-container>
            <ng-container *ngIf="currentStep === 3">Confirmation</ng-container>
          </div>
        </div>
      </div>

      <!-- Desktop Step List -->
      <div class="step-list desktop-only">
        <div class="step-item" [ngClass]="{'active': currentStep === 1, 'completed': currentStep > 1}">
          <div class="step-badge" *ngIf="currentStep <= 1">1</div>
          <div class="step-badge" *ngIf="currentStep > 1">✓</div>
          <div class="step-name">DA Form</div>
        </div>
        <div class="step-item" [ngClass]="{'active': currentStep === 2, 'completed': currentStep > 2}">
          <div class="step-badge" *ngIf="currentStep <= 2">2</div>
          <div class="step-badge" *ngIf="currentStep > 2">✓</div>
          <div class="step-name">REVIEW</div>
        </div>
        <div class="step-item" [ngClass]="{'active': currentStep === 3, 'completed': currentStep > 3}">
          <div class="step-badge" *ngIf="currentStep <= 3">3</div>
          <div class="step-badge" *ngIf="currentStep > 3">✓</div>
          <div class="step-name">Payment</div>
        </div>
        <div class="step-item" [ngClass]="{'active': currentStep === 4, 'completed': currentStep > 4}">
          <div class="step-badge" *ngIf="currentStep <= 4">4</div>
          <div class="step-badge" *ngIf="currentStep > 4">✓</div>
          <div class="step-name">Confirmation</div>
        </div>
      </div>



      <!-- Mobile Segmented Progress Bar -->
      <div class="mobile-segments mobile-only">
        <div class="segment" [ngClass]="{'active': currentStep >= 1}"></div>
        <div class="segment" [ngClass]="{'active': currentStep >= 2}"></div>
        <div class="segment" [ngClass]="{'active': currentStep >= 3}"></div>
        <div class="segment" [ngClass]="{'active': currentStep >= 4}"></div>
      </div>
    </aside>

    <!-- MAIN CONTENT AREA -->
    <main class="da-content-area" [formGroup]="daForm">

      <!-- STEP 1: DA Form -->
      <ng-container *ngIf="currentStep === 1">
        <div class="da-header-section">
          <h1>DA Form</h1>
        </div>

        <div class="da-main-layout">
          <!-- Main Form Column -->
          <div class="main-column">
            <app-da-personal-details [parentForm]="daForm" (loaded)="onSectionLoaded()"></app-da-personal-details>
            <app-da-education [parentForm]="daForm" (loaded)="onSectionLoaded()"></app-da-education>

            <app-da-recommendations [parentForm]="daForm"></app-da-recommendations>
            <app-da-awards [parentForm]="daForm" (loaded)="onSectionLoaded()"></app-da-awards>
          </div>

          <!-- Right Sidebar Panel -->
          <div class="right-column">
            <div class="sticky-panel">
              <div class="da-card info-card">
                <h4>One Application, Five Choices</h4>
                <p>Save time by applying to up to 5 universities with a single application. University specific details
                  will be collected via chat after submission.</p>
              </div>
              <app-da-parents-details [parentForm]="daForm" (loaded)="onSectionLoaded()"></app-da-parents-details>
              <app-da-test-scores [parentForm]="daForm" (loaded)="onSectionLoaded()"></app-da-test-scores>
              <app-da-experience [parentForm]="daForm" (loaded)="onSectionLoaded()"></app-da-experience>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- STEP 2: REVIEW -->
      <ng-container *ngIf="currentStep === 2">
        <app-review *ngIf="mode === 'standard'" (onNext)="goToStep(4)" (loaded)="onSectionLoaded()"></app-review>
        <app-expert-checkout *ngIf="mode === 'expert'" (paymentComplete)="goToStep(4, true)" (cancel)="prevStep()"
          (loaded)="onSectionLoaded()"></app-expert-checkout>
      </ng-container>

      <!-- STEP 3: Payment -->
      <ng-container *ngIf="currentStep === 3">
        <app-payment [txnId]="paymentTxnId" [isSuccess]="paymentIsSuccess" [failureReason]="paymentFailureReason"
          (onNext)="goToStep(4, true)">
        </app-payment>
      </ng-container>

      <!-- STEP 4: Confirmation -->
      <ng-container *ngIf="currentStep === 4">
        <app-confirmation (onNext)="goToDashboard()" (loaded)="onSectionLoaded()"></app-confirmation>
      </ng-container>

      <!-- WIZARD FOOTER (Sticky) — hidden on the Payment step, which has its own actions -->
      <div class="wizard-footer" *ngIf="currentStep !== 3">
        <!-- Left: progress dots + step text -->
        <div class="footer-progress-info">
          <div class="progress-dots">
            <div class="dot" *ngFor="let s of [1,2,3,4]; let idx = index" [class.active]="currentStep === (idx + 1)">
            </div>
          </div>
          <div class="step-text">Step {{ currentStep }} of 4</div>
        </div>

        <!-- Right: Back + Next grouped together -->
        <div class="footer-buttons">
          <button type="button" class="btn btn-secondary" *ngIf="currentStep !== 4" [disabled]="currentStep === 1"
            (click)="prevStep()">
            <i class="pi pi-chevron-left"></i> Back
          </button>
          <div style="display: inline-block;">
            <button type="button" class="btn btn-primary" *ngIf="currentStep !== 4" (click)="nextStep()">
              Next <i class="pi pi-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>

    </main>
  </div>
</ng-container>